
import React , { useState, useEffect }from 'react';
import { Table, Button, Form, message } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
// import { advice } from '../../commonImports/data'
// import { CasesheetContext } from '../../../../context/casesheetContext';
// import MultiSelectEXM from '../../common/multiselectExm';
import SelectWithFetch from '../../common/selectWithFetch'
import { searchGlobalAdvice } from '../../../graphql/queries';
import { withApollo } from 'react-apollo';


// const { TabPane } = Tabs;
// const { Search } = Input;
// const { Option } = Select;


const Advice=(props, objD)=>{
  // const context = useContext(CasesheetContext)
  const [selectExm,setselectExm] = useState([]);
  const [data,setdata] = useState([]);
  const [loading,setloading] = useState(false);


  useEffect(() => {
    if(props.form){
      let values = props.form.getFieldsValue();
      let arr = values.adviceMap;


      if(values.advice != null){
        let obj = values.advice.map((a)=>{
          if(!a){
            return
          }

          let item = null;
          if(arr){
            item = arr.find((b)=> b && b.slugValue == a)
          }

          if(item){
            return{adviceName: item.adviceName, id: a}
          }else{
            return{adviceName: a, id: a}
          }
        })
        setselectExm(obj)

      }
    }
   }, [])
 

const handleDelete=(record)=>{
  let arr = [...selectExm];
  let i = arr.findIndex((item) => item.id == record.id);
  if (i > -1) {
    arr.splice(i,1);
    setselectExm(arr)
  }

    if(props.form){
      props.form.setFieldsValue({
        advice: data
      })
    }
    message.success('Deleted successfully')
}


const handleFetchData=(val)=>{
    setloading(true)
      props.client.query({
        query: searchGlobalAdvice,
        variables:{
          searchValue: val,
          from:0,
          size:100
        },
      }).then((data)=>{
       if(data.data.searchGlobalAdvice){
        setdata(data.data.searchGlobalAdvice)
       }
       setloading(false)
      }).catch((err)=>{
       console.log(err)
       setloading(false)
      })
}

    const columns = [
        {
          title: 'Advice',
          dataIndex: 'adviceName',
          key: 'advice',
         
        },
     
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render(text,record){
              return (
                <Button type="link">
                  <DeleteFilled 
                  onClick={()=>{
                    handleDelete(record)
                  }}/>
                  </Button>)
            }
          },
      ];
      

    return(
        <div>
  
           {/* <MultiSelectEXM
           selectedTest={selectedTest}
           data={dataList}
           
            /> */}
              <SelectWithFetch
                // type="multi"
                loading={loading}
                size="large"
                placeholder="Type to Search Advice"
                // selected={selectExm}
                // custVal={selectExm}
              // custVal={selectExm != undefined && selectExm != null ?
              //   selectExm.map((a)=>{
              //     return{
              //       key: a.id,
              //       label: a.adviceName,
              //       value: a.id
              //     }
              //   })  
              //   : null}
              dropDownEnabled={true}
              dropDownComp={<>
               
              </>}
              handleSearch={(val) => {
                handleFetchData(val)
              }}
              data={data}
              keyName={'id'}
              fields={[
                {
                title: null,
                val: 'adviceName'
              },]}
              setSelectedResult={(val) => {
             
                if(val){
                  // val = val.map((a)=>{
                  //   return{
                  //     adviceName: a.adviceName ? a.adviceName : a.label,
                  //     id: a.id ? a.id : a.key
                  //   }
                  // })
                  let arr = [...selectExm]
                  let item = arr.find((a)=>a.id == val.value)
      
                  if(item){
                    message.warning('Already added')
                    return
                  }

                  arr.push({
                    adviceName: val.adviceName ? val.adviceName : val.label,
                    id: val.id ? val.id : val.key
                  })
                  let modArr = arr.map((a)=>a.id)
                 
                 setselectExm(arr)
                 if(props.form){
                   props.form.setFieldsValue({
                     advice: modArr
                   })
                 }

                }
              }}
            />
        
           <Table 
           style={{marginTop:20}}
           columns={columns}
           dataSource={selectExm}
           />

    <Form.Item
    rules={[{ required: false, message: 'Advice is required' }]}
      name="advice"
     >
       <p></p>
     </Form.Item>
     <Form.Item
 
      name="adviceMap"
     >
       <p></p>
     </Form.Item>
       

        </div>
    )
}

export default withApollo(Advice)